import request from "@/utils/request";

//直播信息
export function getLiveInfo() {
    return request({
        method: "post",
        url: "/home/getLive"
    });
}

//广告位
export function getGuanggaoList() {
    return request({
        method: "post",
        url: "/home/getAd"
    });
}

//议程信息
export function getAgenda(){
    return request({
        method: "post",
        url:"/home/getAgenda"
    })
}
//议程信息-详情
export function getAgendaInfo(data){
    return request({
        method: "post",
        url:"/home/getAgendaInfo",
        data
    })
}
//演讲嘉宾列表
export function getSpeaker(data={}){
    return request({
        method: "post",
        url:"/home/getSpeaker",
        data
    })
}
//演讲嘉宾详情
export function getSideEvent(){
    return request({
        method: "post",
        url:"/home/getActivity"
    })
}

//菜单查询
export function getNavList(){
    return request({
        method: "post",
        url:"/home/getNav"
    })
}

//首页相关信息查询
export function getHomeInfo(){
    return request({
        method: "post",
        url:"/home/home"
    })
}

//直播会看
export function getLiveReview(){
    return request({
        method: "post",
        url:"/home/getLiveSee"
    })
}

//合作伙伴
export function getPartner(){
    return request({
        method: "post",
        url:"/home/getPartners"
    })
}

//SEO信息查询
export function getSeoInfo(){
    return request({
        method: "post",
        url:"/index/getSeo"
    })
}
